import { Box, Typography } from "@mui/material"
import RowMenu from "../../Menu/RowMenu"

const GoalsCell = (props: any) => {
  const { row, renderedCellValue, handleApplyToRow, handleClearRow } = props

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0px 10px",
      }}
    >
      <Box></Box>
      <Box></Box>
      <Typography>{renderedCellValue}</Typography>
      <RowMenu
        handleApplyToRow={handleApplyToRow}
        handleClearRow={handleClearRow}
        valueToApply={renderedCellValue}
        row={row}
      />
    </Box>
  )
}

export default GoalsCell
